import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "product-card" }
const _hoisted_2 = {
  key: 0,
  class: "product-container"
}
const _hoisted_3 = { class: "d-flex justify-content-between" }
const _hoisted_4 = { class: "product-image" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "d-flex flex-column flex-grow-1 product-data-container" }
const _hoisted_8 = { class: "product-title" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "product-price-data" }
const _hoisted_11 = { style: {"display":"inline"} }
const _hoisted_12 = { style: {"text-decoration":"line-through","display":"inline"} }
const _hoisted_13 = { style: {"display":"inline"} }
const _hoisted_14 = { style: {"display":"inline","color":"#FF057D"} }
const _hoisted_15 = { style: {"display":"inline","color":"#FF057D"} }
const _hoisted_16 = ["href"]


import { TaazeProductUrlCreator } from '@/utils/taazeProductUrlCreator';
import Product from '@/models/Product';
import { TaazeMediaUrlCreator } from '@/utils/taazeMediaUrlCreator';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductCard',
  props: {
    product: {}
  },
  setup(__props: any) {

const props = __props;

const taazeProductUrlCreator = new TaazeProductUrlCreator();
const taazeMediaUrlCreator = new TaazeMediaUrlCreator();

const productUrl = taazeProductUrlCreator.createProductUrl(props.product.id);
const addToCartUrl = taazeProductUrlCreator.createAddToCartUrl(props.product.id);
const productMediaUrl = taazeMediaUrlCreator.createProductImageUrl(props.product.id)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.product != null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("a", { href: _unref(productUrl) }, [
                _createElementVNode("img", {
                  class: "img-fluid",
                  src: _unref(productMediaUrl),
                  alt: "",
                  srcset: ""
                }, null, 8, _hoisted_6)
              ], 8, _hoisted_5)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("a", { href: _unref(productUrl) }, _toDisplayString(props.product.name), 9, _hoisted_9)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_11, [
                    _cache[0] || (_cache[0] = _createTextVNode("定價：NT$ ")),
                    _createElementVNode("div", _hoisted_12, _toDisplayString(props.product.price.listPrice), 1)
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_13, [
                    _cache[1] || (_cache[1] = _createTextVNode("優惠價：")),
                    _createElementVNode("div", _hoisted_14, _toDisplayString(Math.ceil((props.product.price.salePrice /
                                    props.product.price.listPrice) * 100)), 1),
                    _cache[2] || (_cache[2] = _createTextVNode(" 折，NT$ ")),
                    _createElementVNode("div", _hoisted_15, _toDisplayString(props.product.price.salePrice), 1)
                  ])
                ])
              ]),
              _createElementVNode("a", {
                href: _unref(addToCartUrl),
                type: "button",
                class: "btn add-to-cart-button align-self-end"
              }, _cache[3] || (_cache[3] = [
                _createElementVNode("div", null, [
                  _createElementVNode("svg", {
                    width: "48",
                    height: "48",
                    viewBox: "0 0 48 48",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    _createElementVNode("path", {
                      d: "M32.0095 28.46L33.7095 21C33.7595 20.78 33.7095 20.54 33.5595 20.36C33.4195 20.18 33.1995 20.08 32.9795 20.08C30.7595 20.09 28.5495 20.09 26.3295 20.08C24.2895 20.08 22.2495 20.07 20.2095 20.08L19.3295 16.32C19.2495 15.98 18.9495 15.74 18.5995 15.74L15.0195 15.73C14.5995 15.75 14.2695 16.06 14.2695 16.47C14.2695 16.88 14.5995 17.22 15.0195 17.22L17.9995 17.24L20.6395 28.47C20.7195 28.81 21.0195 29.05 21.3695 29.05H22.2195C21.3295 29.11 20.6195 29.84 20.6195 30.75C20.6195 31.69 21.3895 32.46 22.3295 32.46C23.2695 32.46 24.0395 31.69 24.0395 30.75C24.0395 29.84 23.3295 29.11 22.4395 29.05H30.0595C29.1695 29.11 28.4595 29.84 28.4595 30.75C28.4595 31.69 29.2295 32.46 30.1695 32.46C31.1095 32.46 31.8795 31.69 31.8795 30.75C31.8795 29.84 31.1695 29.11 30.2795 29.05H31.2995C31.6295 29.05 31.9395 28.8 32.0095 28.46ZM21.9595 27.55L20.5595 21.58C22.4795 21.57 24.3995 21.58 26.3195 21.58C28.2295 21.58 30.1295 21.59 32.0395 21.58L30.6795 27.54H21.9595V27.55Z",
                      fill: "#FFFFFF",
                      transform: "scale(2.0) translate(-11 -14)"
                    })
                  ]),
                  _createElementVNode("div", null, " 直接購買 ")
                ], -1)
              ]), 8, _hoisted_16)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})